export function formatNumber(value) {
  const num = Number(value ?? 0);
  if (!Number.isFinite(num)) return "0";

  const roundedToTwo = Math.round(num * 100) / 100;

  if (Number.isInteger(roundedToTwo)) {
    return roundedToTwo.toLocaleString();
  }

  return roundedToTwo.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
